import _regeneratorRuntime from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { defineComponent } from 'vue';
import WalkthroughPointer from './WalkthroughPointer.vue';
export default defineComponent({
  name: 'TopActionBar',
  components: {
    WalkthroughPointer: WalkthroughPointer
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    console.log('<<<<<<<<< ConversationSettings mounted >>>>>>>>>');
    // this.$store.commit('updateShowAvatarSelector', true)
  },
  methods: {
    toggleSimpleResponses: function toggleSimpleResponses() {
      if ('vibrate' in navigator) {
        this.$store.dispatch('buzzPhone');
        // Vibration API is supported on this device
      }
      this.$store.commit('updateSimpleResponses', !this.$store.state.simpleResponses);
    },
    returnVoiceTextLabel: function returnVoiceTextLabel() {
      if (this.$store.state.textOnlyMode) {
        return 'Text';
      } else {
        return 'Single';
      }
    },
    openAvatarSelector: function openAvatarSelector() {
      this.$store.commit('updateShowAvatarSelector', true);
    },
    toggleTextVoice: function toggleTextVoice() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if ('vibrate' in navigator) {
                _this.$store.dispatch('buzzPhone');
                // Vibration API is supported on this device
              }
              _context.next = 3;
              return _this.$store.dispatch('checkFeatureEnabled', 'continuous');
            case 3:
              if (_context.sent) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return");
            case 5:
              console.log('clicking on toggleTextVoice');
              // if text only mode is active turn it off
              if (!_this.$store.state.brillianceMode) {
                _context.next = 12;
                break;
              }
              _this.$store.commit('disableContinuousListenMode');
              _this.$store.commit('updateBrillianceMode', false);
              _this.$store.commit('disableContinuousListenMode');
              // this.$store.commit('updateTextOnlyMode', false)
              // if text only mode is not active turn it on 
              _context.next = 25;
              break;
            case 12:
              if (_this.$store.state.continuousListenMode) {
                _context.next = 16;
                break;
              }
              _this.$store.commit('enableContinuousListenMode');
              // this.$store.commit('updateTextOnlyMode', false)
              _context.next = 25;
              break;
            case 16:
              _context.next = 18;
              return _this.$store.dispatch('checkFeatureEnabled', 'brilliance');
            case 18:
              if (_context.sent) {
                _context.next = 24;
                break;
              }
              _this.$store.commit('disableContinuousListenMode');
              _this.$store.commit('updateBrillianceMode', false);
              _this.$store.commit('disableContinuousListenMode');
              _context.next = 25;
              break;
            case 24:
              _this.$store.commit('updateBrillianceMode', true);
            case 25:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    toggleSettingsMenu: function toggleSettingsMenu() {
      if (this.$store.state.ShowMainMenu) {
        this.$store.commit('mainMenuClose');
      } else {
        this.$store.commit('mainMenuOpen');
      }
    },
    updateContext: function updateContext() {
      if ('vibrate' in navigator) {
        this.$store.dispatch('buzzPhone');
        // Vibration API is supported on this device
      }
      if (this.$store.state.useContext) {
        console.log('updating context to false');
        this.$store.commit('updateContext', false);
        localStorage.setItem('useContext', false);
      } else {
        console.log('updating context to true');
        this.$store.commit('updateContext', true);
        localStorage.setItem('useContext', true);
      }
    },
    toggleMemories: function toggleMemories() {
      if ('vibrate' in navigator) {
        this.$store.dispatch('buzzPhone');
        // Vibration API is supported on this device
      }
      // if both on
      if (this.$store.state.useMemories && this.$store.state.storeMemories) {
        // toggle off use
        this.$store.commit('updateUseMemories', false);

        //if use off and store on 
      } else if (!this.$store.state.useMemories && this.$store.state.storeMemories) {
        //toggle off store 
        this.$store.commit('updateStoreMemories', false);
        this.$store.commit('updateUseMemories', true);

        // if both off
      }
      // if use on and store off
      else if (this.$store.state.useMemories && !this.$store.state.storeMemories) {
        this.$store.commit('updateUseMemories', false);
      } else if (!this.$store.state.useMemories && !this.$store.state.storeMemories) {
        // turn both on 
        this.$store.commit('updateStoreMemories', true);
        this.$store.commit('updateUseMemories', true);
      }
    }
  }
});